export default __webpack_public_path__ + "static/media/dataplayer.564b2485.jpg";